<template>
  <div class="ordinary-material">
    <material-file />
  </div>
</template>

<script>
import MaterialFile from './components/material-file'
export default {
  name: 'OrdinaryMaterial',
  components: {
    MaterialFile
  }
}
</script>

<style lang="scss" scoped>
.ordinary-material {
  height: 100%;
  display: flex;
  flex-direction: column;

  .main-content {
    height: 100%;
    display: flex;
    flex: 1;
    flex-direction: column;
    overflow: hidden;
  }
}
</style>

<style lang="scss">
.ordinary-material-popover {
  padding: 10px 10px;

  .mention-text {
    display: flex;

    .icon-ds-tishi {
      font-size: 14px;
      color: #faad14;
      margin-right: 8px;
    }

    .txt {
      font-size: 13px;
      line-height: 21px;
      color: #595959;
    }
  }
}

.ordinary-material-delete-confirm {
  .mention-text {
    font-size: 14px;
    color: #595959;

    .icon-ds-tishi {
      font-size: 14px;
      color: #faad14;
      margin-right: 8px;
    }
  }

  .button {
    margin-top: 12px;
    text-align: right;
  }
}

.ordinary-material-tooltip {
  background-color: rgba(0, 0, 0, 0.75) !important;
  border-color: rgba(0, 0, 0, 0.75) !important;
  color: #fff !important;

  .popper__arrow {
    border-top-color: rgba(0, 0, 0, 0.75) !important;
  }

  .popper__arrow::after {
    border-top-color: rgba(0, 0, 0, 0.75) !important;
  }
}
</style>
